export default __webpack_public_path__ + "static/media/orangeArrow.e70c4b87.png";